import { env } from "~/env";

export const VisitCancellationPolicy = () => (
  <div className="bg-shade-gray flex flex-col gap-2 rounded-lg p-4">
    <p className="text-indigo-charcoal self-center font-sans text-base font-medium leading-7 md:self-start md:text-lg">
      Visit cancellation policy
    </p>
    <p className="text-indigo-charcoal text-sm leading-6 md:text-base">
      Please cancel 24 hours before your visit to avoid a $
      {env.VITE_LATE_CANCELLATION_FEE} cancellation/no show fee.
    </p>
  </div>
);
